<div class="ft-panel" (click)="showModal.emit()">
    <div class="ft-heading ft-text-plus-2">{{ 'flipto.components.goals.Friends' | translate }}</div>
    @if (!goals()?.length) {
        <span>{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
    }
    @for (goal of goals(); track goal) {
        <div class="goal-group">
            <div class="ft-label">{{ goal | goalName }}</div>
            <span [innerHTML]="goal | goalDescription: culture()"></span>
        </div>
    }
</div>
